module.exports = __webpack_public_path__ + "img/nike-banner01.37528b56.jpg";